import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {
  deleteCategorys,
  getCategorys,
  getDepartments,
  GetDynamicOptions,
  getProfitCenter,
  insertCategory,
} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import Select from "react-select";
import { useSearchParams } from "react-router-dom";
import FilterComponent from "../pages/FilterComponent";
import { getSecureItem } from "../../services/SecureStorage";
export default function Category() {
  const UID = getSecureItem("userId");
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [editCategoryModal, setEditCategoryModal] = useState(false);
  const [categorys, setCategorys] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [profitCenters, setProfitCenters] = useState([]);
  const [department, setDepartment] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoryIdToDelete, setcategoryIdToDelete] = useState(null);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const [categoryData, setCategoryData] = useState({
    Id: "",
    Name: "",
    Narration: "",
    Code: "",
    DepartmentId: "",
    AdvAmount: "",
    IsSpDayApply: "",
    NoofTerms: "",
    Status: 0,
    UserId: UID,
    SalaryGeneration: "",
    IsAllEmployee: ''
  });

  const openAddCategoryModal = () => {
    setCategoryData({});
    setAddCategoryModal(!addCategoryModal);
  };
  const openEditCategoryModal = (data) => {

    const ProfitCenterName = profitCenters.find((item) => {
      if (item.Id == data?.ProfitCenterId) {
        return item?.Name;
      }
    });
    const DepartmentName = department.find((item) => {
      if (item.Id == data?.DepartmentId) {
        return item?.Name;
      }
    });
    setEditCategoryModal(!editCategoryModal);
    setCategoryData({
      ...data,
      ProfitCenter: ProfitCenterName?.Name,
      Department: DepartmentName?.Name,
      UserId: UID || "",
    });
  };
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      position: 'absolute',
      bottom: '100%',  // Position menu above the select input
      top: 'auto',    // Remove default top positioning
      marginBottom: '5px', // Add some space between input and menu
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px', // Adjust this value as needed
    })
  };
  const clearData = () => {
    setCategoryData({
      Id: "",
      Name: "",
      Narration: "",
      Code: "",
      DepartmentId: "",
      IsSpDayApply: false,
      NoofTerms: "",
      Status: 0,
      UserId: UID,
      SalaryGeneration: "",
      IsAllEmployee: '',
    });
  };
  const clearDataEdit = () => {
    setCategoryData((ref) => ({
      ...ref,
      Name: "",
      Narration: "",
      Code: "",
      DepartmentId: "",
      IsSpDayApply: false,
      NoofTerms: "",
      UserId: UID,
      Department: "Select Department",
      SalaryGeneration: "",
      IsAllEmployee: '',
    }));
  };

  const fetchCategorys = async () => {
    try {
      const data = await getCategorys(UID);
      setCategorys(data.data.data);
      setIsFilterVisible(false)
    } catch (error) {
      console.error("Error fetching categorys", error);
    }
    // setLoading(false);
  };


  const handleChange = (e) => {
    // Handle react-select's onChange
    if (Array.isArray(e)) {
      const selectedValues = e.map((option) => option.value); // Extract values
      setCategoryData((prev) => ({
        ...prev,
        DepartmentId: selectedValues,
      }));
      return;
    }

    const { name, type, value, checked } = e.target;

    if (type === "checkbox") {
      setCategoryData((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else {
      if (name === "DepartmentId") {
        setCategoryData((prev) => ({
          ...prev,
          DepartmentId: value,
        }));
      } else {
        setCategoryData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    }
  };

  
  const handleChangeEdit = (e) => {
    const { name, type, value, checked } = e.target;

    if (type === "checkbox") {
      setCategoryData((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else {
      // For department, update both ID and name if needed
      if (name === "DepartmentId") {
        setCategoryData((prev) => ({
          ...prev,
          DepartmentId: value,
        }));
      } else {
        setCategoryData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Prepare the updated category data
      const updatedCategoryData = {
        ...categoryData,
        UserId: UID,
        DepartmentId: '',
      };

      // Insert category and await the response
      const response = await insertCategory(updatedCategoryData);

      if (response?.data.StatusCode === 200) {
        toast.success(response.message || "Category added successfully")

      } else {
        toast.error("Failed to add the category. Please try again.");
      }


      // Refresh category list and close modal
      await fetchCategorys();
      openAddCategoryModal();
    } catch (error) {
      // Extract and handle error message
      const errorMessage =
        error.response?.data?.error || error.message || "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error("This Category name already exists.");
      } else {
        toast.error("Error occurred while adding the category.");
      }

      console.error("Error adding category:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {


      const data = {
        ...categoryData,
        UserId: UID
      };
      const response = await insertCategory(data);

      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchCategorys();
        openEditCategoryModal();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error("Error occurred while Updating Category");
      } else {
        toast.error("Error occurred while editing Category.");
      }
      console.error("Error Updating Category:", error);
    } finally {
      setLoading(false);
    }
  };
  const openModal = (categoryId) => {
    setcategoryIdToDelete(categoryId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setcategoryIdToDelete(null);
  };

  const confirmDelete = () => {
    if (categoryIdToDelete) {
      removeCategory(categoryIdToDelete);
    }
    closeModal();
  };
  const removeCategory = async (categoryId) => {
    const removeData = { Id: categoryId, TableName: "Category" };

    try {
      const res = await deleteCategorys(removeData, UID); // Add await here

      if (res && res.data) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("Category deleted successfully");
          fetchCategorys(); // Refresh the list
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting Category");
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Category.";
        toast.error("Category already using cannot delete");
      } else {
        console.error("Error removing Category:", error);
        toast.error("Error deleting Category. Please try again.");
      }
    }
  };


  //
  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: " Category Name ",
      selector: (row) => row.Name,
      sortable: true,
    },
    {
      name: " Remarks",
      selector: (row) => row.Narration || 'N/A',
      sortable: true,
    },
    // {
    //   name: "Departments",
    //   // selector: (row) => row.Department,
    //   // sortable: true,
    //   selector: (row) => {
    //     const departmentName = department?.find(
    //       (el) => el.Id === row.DepartmentId
    //     );

    //     return departmentName ? departmentName.Name : "N/A"; // Handle case where category is not found
    //   },
    // },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditCategoryModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];
  const filteredItems = dataFilter.filter((item) => {
    const departmentName = department?.find(
      (el) => el.Id === item.DepartmentId
    )?.Name;

    // Check if any of the fields match the filter text
    return (
      item.Name.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Narration?.toLowerCase().includes(filterText.toLowerCase()) ||
      (departmentName &&
        departmentName.toLowerCase().includes(filterText.toLowerCase()))
    );
  });

  const subHeaderComponentMemo = useMemo(() => { }, [
    filterText,
    resetPaginationToggle,
  ]);

  useEffect(() => {
    setLoading(true);
    fetchCategorys();
  }, []);

  useEffect(() => {
    if (categorys && categorys.length > 0) {
      const updatedData = categorys.map((item, index) => {
        const departmentName =
          department.find((dept) => dept.Id === item.DepartmentId)?.Name || "";

        return {
          Slno: index + 1,
          Id: item.Id || "",
          Name: item.Name || "",
          Narration: item.Narration || "",
          Code: item.Code || "",
          UserId: item.UserId || "",
          DepartmentId: item.DepartmentId || "",
          Department: departmentName,
          IsSpDayApply: item.IsSpDayApply || "",
          IsAllEmployee: item.IsAllEmployee || '',
          SalaryGeneration: item.SalaryGeneration || "",
        };
      });
      setDataFilter(updatedData);
    } else {
      setDataFilter([]);
    }
  }, [categorys, department]);


  const [salaryOptions, setSalaryOptions] = useState([]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await GetDynamicOptions({
          optionType: "SalaryGenerationOption",
        });

        setSalaryOptions(response.data.data); // Make sure response structure is correct
      } catch (error) {
        console.error("Error fetching salary options:", error);
      }
    };

    fetchOptions();
  }, []);




  useEffect(() => {
    const fetchProfitCenters = async () => {
      try {
        const response = await getProfitCenter(UID);
        const responses = await getDepartments(UID);

        setDepartment(responses.data.data);
        setProfitCenters(response.data.data);
        setLoading(false)
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };

    fetchProfitCenters();
  }, []);

  const departmentOptions = department.map((dept) => ({
    value: dept.Id,
    label: dept.Name,
  }));


 

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults); // Update state with the filtered data
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this category?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Category" />
        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by Category"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button onClick={handleClear} className="btn btn-danger">
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button onClick={openAddCategoryModal} className="btn btn-primary">
            Add New
          </button>
        </div>
      </div>
      {isFilterVisible && (
        <FilterComponent
          columns={columnsFilter}
          data={categorys}
          onFilter={handleFilter}
        />
      )}

      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>
      {addCategoryModal && (
        <>
          <div className="fixed p-15 w-full max-w-[800px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Add Category
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openAddCategoryModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form
                onSubmit={handleSubmit} // Attach your submit handler
                className="my-10 md:px-10 px-[7px]"
              >
                <div className="my-10 md:px-10 px-[7px] max-h-[85vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Category Name  <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        required
                        name="Name"
                        placeholder="Name"
                        value={categoryData.Name}
                        onChange={handleChange}
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>
                   




                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Salary Generation Option{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="SalaryGeneration"
                        value={categoryData?.SalaryGeneration}
                        onChange={handleChange}
                        required
                        className="p-2 border rounded"
                      >
                        <option value="" disabled selected>
                          Select an option
                        </option>
                        {salaryOptions.length > 0 ? (
                          salaryOptions.map((option, index) => (
                            <option key={index} value={option.OptionName}>
                              {option.OptionName}
                            </option>
                          ))
                        ) : (
                          <option disabled>No options available</option>
                        )}
                      </select>

                    </div>
                    <div className="form-group flex col-span-12 flex-row  w-full">
                      <label className="w-full">Apply to all employees in the category </label>
                      <input
                        type="checkbox"
                        id="IsAllEmployee"
                        name="IsAllEmployee"
                        placeholder="IsAllEmployee"
                        value={categoryData.IsAllEmployee}
                        onChange={handleChange}
                        checked={!!categoryData.IsAllEmployee}

                      // checked={categoryData.IsSpDayApply}
                      />
                    </div> */}
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks</label>

                      <input
                        type="text"
                        id="narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={categoryData.Narration}
                        onChange={handleChange}
                      />
                    </div>

                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                    disabled={loading}
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            // onClick={openAddCategoryModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}

      {/* ==========================================================================edit========================================================================================= */}
      {editCategoryModal && (
        <>
          <div className="fixed p-15 w-full max-w-[750px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Edit Category
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openEditCategoryModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form
                onSubmit={handleEdit} // Attach your submit handler
                className="my-10 md:px-10 px-[7px] "
              >
                <div className="my-10 md:px-10 px-[7px] max-h-[75vh] overflow-auto cus-scrollbar-point-bottom">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Category Name  <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="Name"
                        name="Name"
                        placeholder="Name"
                        value={categoryData.Name}
                        onChange={handleChangeEdit}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>
                   

                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Salary Generation Option{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="SalaryGeneration"
                        value={categoryData?.SalaryGeneration}
                        onChange={handleChange}
                        required
                        className="p-2 border rounded"
                      >
                        <option value="" disabled selected>
                          Select an option
                        </option>
                        {salaryOptions.length > 0 ? (
                          salaryOptions.map((option, index) => (
                            <option key={index} value={option.OptionName}>
                              {option.OptionName}
                            </option>
                          ))
                        ) : (
                          <option disabled>No options available</option>
                        )}
                      </select>

                    </div> */}
                    {/* <div className="form-group flex col-span-12 flex-row  w-full">
                      <label className="w-full">Apply to all employees in the category </label>
                      <input
                        type="checkbox"
                        id="IsAllEmployee"
                        name="IsAllEmployee"
                        placeholder="IsAllEmployee"
                        value={categoryData.IsAllEmployee}
                        onChange={handleChange}
                        checked={!!categoryData.IsAllEmployee}

                      // checked={categoryData.IsSpDayApply}
                      />
                    </div> */}
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="Narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={categoryData.Narration}
                        onChange={handleChangeEdit}
                      />
                    </div>
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            // onClick={openEditCategoryModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
